import React from 'react';

const Particle = ({ size, top, left, animationDelay }) => {
  const style = {
    fontSize: `${size * 4}px`,
    top: `${top}%`,
    left: `${left}%`,
    animationDelay: `${animationDelay}s`,
  };

  // Randomly choose between "1" and "0"
  const binary = Math.random() > 0.5 ? '1' : '0';

  return <div className="particle" style={style}>{binary}</div>;
};

export default Particle;
